import cn from 'clsx'
import { FC } from 'react'

import { Typography } from '@/components/ui'

import { TStatus } from '@/types/task.interface'

interface IProps {
	status: TStatus
	className?: string
}

const Status: FC<IProps> = ({ status, className }) => {
	const colors: Record<TStatus, string> = {
		added: 'text-gray-700 bg-gray-50 border-gray-100',
		waiting: 'text-gray-700 bg-gray-50 border-gray-100',
		in_progress: 'text-yellow-700 bg-yellow-50 border-yellow-100',
		stopped: 'text-red-475 bg-red-50 border-red-100',
		failed: 'text-gray-700 bg-gray-50 border-gray-100',
		finished: 'text-green-700 bg-green-50 border-green-100'
	}

	const text: Record<TStatus, string> = {
		added: 'Added',
		waiting: 'Waiting',
		in_progress: 'In progress',
		stopped: 'Stopped',
		failed: 'Failed',
		finished: 'Finished'
	}

	return (
		<Typography
			variant='text-large'
			className={cn(
				colors[status],
				'w-fit leading-none px-[6px] py-[4px] border rounded-[4px]',
				className
			)}
		>
			{text[status]}
		</Typography>
	)
}

export default Status
